<div class="card mb-4">
    <div class="card-body">
        <h6>Security Settings</h6>
        <p>Manage your password.</p>

        <button class="btn btn-ms-secondary me-2" (click)="openResetPasswordModal()">
            Reset Password
        </button>

        <ms-confirmation-modal #userSecurityConfirmationModalRef modalId="userSecurityConfirmationModal"
            [(isSubmitting)]="isSubmitting" confirmButtonText="Yes" (confirmed)="onConfirmationModalConfirmed()"
            (cancelled)="onConfirmationModalCanceled()" />

        <ms-info-modal #userSecurityInfoModalRef modalId="userSecurityInfoModal"
            (onConfirmClicked)="onInfoModalConfirmed()" />
    </div>
</div>